import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import { useToast } from '@/hooks/use-toast';
import Button from '@appchoose/button';
import { Check, Link } from 'lucide-react';

function ShareOfferButton() {
  const { t } = useTranslation();
  const { dealId } = useParams<{ dealId: string }>();
  const { toast } = useToast();

  const [isCopied, setIsCopied] = useState(false);

  if (!dealId) {
    return null;
  }

  const handleShareOffer = async () => {
    try {
      const shareLink = `${window.location.origin}/deal/${dealId}`;
      await navigator.clipboard.writeText(shareLink);
      setIsCopied(true);
      setTimeout(() => setIsCopied(false), 2000);
      toast({
        title: t('components.share_offer.link_generated'),
        description: t('components.share_offer.link_copied_to_clipboard'),
      });
    } catch {
      toast({
        title: t('general.error'),
        description: t('components.share_offer.link_generation_error'),
        variant: 'destructive',
      });
    }
  };

  return (
    <Button
      type="button"
      onClick={handleShareOffer}
      appearance="outline"
      className="flex items-center gap-2 whitespace-nowrap border border-gray-300 font-medium"
      disabled={isCopied}
      data-testid="share-offer-button"
    >
      {isCopied ? <Check className="h-4 w-4" /> : <Link className="h-4 w-4" />}
      {isCopied
        ? t('components.share_offer.link_copied')
        : t('ui-v2.header.action-copy-link')}
    </Button>
  );
}

export default ShareOfferButton;
